import { Card } from "@common/components/ui/card"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { DepartmentForm } from "./-components/form/department-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/departments/create",
)({
  staticData: { breadcrumb: "New department" },
  component: CreateDepartmentPage,
})

function CreateDepartmentPage(): React.ReactElement {
  const navigate = useNavigate()
  const showToast = useCustomToast()

  return (
    <PageContent>
      <PageTitle title="New department" />
      <Card className="p-4 shadow-none">
        <DepartmentForm
          onCreate={(created) => {
            showToast("Created", `${created.name} added.`, "success")
            navigate({ to: "/settings/workspace/departments" })
          }}
        />
      </Card>
    </PageContent>
  )
}
